import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { IonApp } from '@ionic/angular/standalone';
import { HttpClientModule } from '@angular/common/http';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

// Declare gtag function from Google Analytics script
declare let gtag: Function;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [IonApp, RouterOutlet, HttpClientModule],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  private readonly CANONICAL_DOMAIN = 'https://app.hobbiebuddy.com';
  
  constructor(
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {}
  
  ngOnInit() {
    // Track page views with Google Analytics and force opacity fix on every route change
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      const pageUrl = event.urlAfterRedirects;
      
      // Update canonical URL for SEO
      this.updateCanonicalUrl(pageUrl);
      
      // Track page view in Google Analytics
      if (typeof gtag !== 'undefined') {
        // Use setTimeout to ensure gtag is fully loaded
        setTimeout(() => {
          console.log('[GA] Tracking page view:', pageUrl);
          
          gtag('config', 'G-HYY9FT9H3F', {
            page_path: pageUrl,
            page_title: document.title
          });
          
          // Also send as a page_view event for better tracking
          gtag('event', 'page_view', {
            page_path: pageUrl,
            page_title: document.title
          });
        }, 100);
      } else {
        console.warn('[GA] gtag not loaded yet');
      }
      
      // Run multiple times to catch lazy-loaded components
      setTimeout(() => this.forceOpacityFix(), 50);
      setTimeout(() => this.forceOpacityFix(), 200);
      setTimeout(() => this.forceOpacityFix(), 500);
    });
  }
  
  private updateCanonicalUrl(path: string) {
    // Remove existing canonical link if present
    const existingCanonical = this.document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }
    
    // Create new canonical link with preferred domain
    const canonical = this.document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    canonical.setAttribute('href', `${this.CANONICAL_DOMAIN}${path}`);
    this.document.head.appendChild(canonical);
    
    console.log('[SEO] Canonical URL set to:', `${this.CANONICAL_DOMAIN}${path}`);
  }
  
  private forceOpacityFix() {
    const selectors = [
      'app-dashboard', 'app-profile', 'app-matches', 'app-hobbies', 
      'app-my-hobbies', 'app-create-hobby',
      'ion-content', 'ion-card', 'ion-list', 'ion-item',
      'ion-checkbox', 'ion-radio', 'ion-button'
    ];
    
    selectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach((el: any) => {
        if (el && el.style) {
          el.style.opacity = '1';
          el.style.visibility = 'visible';
        }
      });
    });
  }
}
